import { Calendar, Mail, Phone, Shield, User } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';

import { useCurrentUser } from '@/hooks/useCurrentUser';

import { formatDate } from '@/lib/date';

export const ProfileDetail = () => {
  const { userData } = useCurrentUser();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Personal Information */}
      <Card className="bg-muted rounded-2xl p-1 pt-0 gap-0 border-0 shadow-none flex flex-col">
        <CardHeader className="flex flex-col px-5 py-3">
          <CardTitle className="text-sm flex items-center gap-2">Personal information</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-3 bg-card p-5 rounded-xl shadow-sm flex-1">
          <div className="flex items-center gap-3">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium">Email</p>
              <p className="text-sm text-muted-foreground">{userData.email}</p>
            </div>
          </div>
          <Separator />
          <div className="flex items-center gap-3">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium">Phone number</p>
              <p className="text-sm text-muted-foreground">
                {userData.phone_number || 'Not provided'}
              </p>
            </div>
          </div>
          <Separator />
        </CardContent>
      </Card>

      {/* Account Information */}
      <Card className="bg-muted rounded-2xl p-1 pt-0 gap-0 border-0 shadow-none flex flex-col">
        <CardHeader className="flex flex-col px-5 py-3">
          <CardTitle className="text-sm flex items-center gap-2">Account information</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-3 bg-card p-5 rounded-xl shadow-sm flex-1">
          <div className="flex items-center gap-3">
            <Shield className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium">Role</p>
              <p className="text-sm text-muted-foreground">{userData.role.name}</p>
            </div>
          </div>
          <Separator />
          <div className="flex items-center gap-3">
            <Calendar className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium">Member since</p>
              <p className="text-sm text-muted-foreground">{formatDate(userData.created_at)}</p>
            </div>
          </div>
          <Separator />
          <div className="flex items-center gap-3">
            <User className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium">Last login</p>
              <p className="text-sm text-muted-foreground">
                {formatDate(userData.last_logged_in_at)}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
